import * as React from 'react';
import { ArticleHeading2 } from '@cian/ui-kit';
import * as styles from './RealtorCatalogLinkDesktop.css';

interface IRealtorCatalogLinkDesktop {
  onLinkClick: () => void;
}

export const RealtorCatalogLinkDesktop: React.FunctionComponent<
  React.PropsWithChildren<IRealtorCatalogLinkDesktop>
> = ({ onLinkClick }) => (
  <div className={styles['container']} data-testid="catalog_link_desktop">
    <ArticleHeading2>
      Можете выбрать риелтора сами&nbsp;&mdash; в&nbsp;
      <a className={styles['link']} href="/realtors" onClick={onLinkClick}>
        каталоге&nbsp;риелторов ↗
      </a>
    </ArticleHeading2>
  </div>
);
